import { Inject } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { OddService } from "app/shared/services/odd.service";
import { Odd } from "app/shared/models/odd.interface";

export class OddsResolver implements Resolve<Odd[]> {
  constructor(@Inject(OddService) private service: OddService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Odd[]> {
    return this.service.getOdds();
  }
}